import React from 'react';

import { Card, Descriptions, Table, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLoaderData } from 'react-router-dom';
import ListPageHeader from '@shared/ListPageHeader';

const STATUS_COLORS = {
  open: 'blue',
  closed: 'orange',
  invoiced: 'green',
};

export default function AdminBillingsShow() {
  const { t } = useTranslation();
  const billing = useLoaderData();

  if (!billing) {
    return null;
  }

  const itemColumns = [
    {
      title: t('admin.billings.fields.billing_date'),
      dataIndex: 'billing_date',
      key: 'billing_date',
    },
    {
      title: t('admin.billings.fields.billing_type'),
      dataIndex: 'billing_type',
      key: 'billing_type',
      render: (type) => (
        <Tag color={type === 'storage' ? 'blue' : 'purple'}>
          {t(`admin.billings.types.${type}`)}
        </Tag>
      ),
    },
    {
      title: t('admin.billings.fields.storage_mode'),
      dataIndex: 'storage_mode',
      key: 'storage_mode',
      render: (mode) => mode ? t(`enums.merchant.storage_billing_mode.${mode}`, { defaultValue: mode }) : '-',
    },
    {
      title: t('admin.billings.fields.description'),
      key: 'description',
      render: (_, record) => record.breakdown?.description || '-',
    },
    {
      title: t('admin.billings.fields.billable_units'),
      dataIndex: 'billable_units',
      key: 'billable_units',
      align: 'right',
      render: (val) => Number(val).toLocaleString(),
    },
    {
      title: t('admin.billings.fields.unit_price'),
      dataIndex: 'unit_price',
      key: 'unit_price',
      align: 'right',
      render: (val) => Number(val).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 4 }),
    },
    {
      title: t('admin.billings.fields.amount'),
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      render: (val) => Number(val).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
  ];

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['billings', { label: billing.name }]}
      />

      <Card style={{ marginBottom: 16 }}>
        <Descriptions column={2} bordered size="small">
          <Descriptions.Item label={t('admin.billings.fields.period')}>
            {billing.period_start} ~ {billing.period_end}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.billings.fields.status')}>
            <Tag color={STATUS_COLORS[billing.status]}>
              {t(`admin.billings.statuses.${billing.status}`)}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.billings.fields.total_amount')}>
            {Number(billing.total_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </Descriptions.Item>
          <Descriptions.Item label={t('admin.billings.fields.items_count')}>
            {billing.billing_items?.length || 0}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title={t('admin.billings.show.items_title')}>
        <Table
          columns={itemColumns}
          dataSource={billing.billing_items || []}
          rowKey="id"
          pagination={false}
          size="small"
        />
      </Card>
    </div>
  );
}
